import React, { useState, useEffect } from 'react';
import Popup from '../../components/Popup';
import ConfirmPopup from '../../components/ConfirmPopup';
import useApi from '../../hooks/useApi';

import { ColumnWrapper, Content } from './styles';

const SessionLeavePopup = ({ popupIsOpen, userToken, flash, onClose, sessionId }) => {
  const { getData, postData, loading } = useApi(userToken);
  const [allowLeaving, setAllowLeaving] = useState('');
  const [conditionsMet, setConditionsMet] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  useEffect(() => {
    const getLeavingConditions = async () => {
      const response = await getData(`/learn/${sessionId}/leaving-conditions`);
      if (response.success) {
        const { allow_leaving, conditions_met } = response.body;
        setAllowLeaving(allow_leaving);
        setConditionsMet(conditions_met);
      } else {
        flash(i18n.__('app_error_alert'));
      }
    };
    if (popupIsOpen) {
      getLeavingConditions();
    }
  }, [popupIsOpen]);

  if (!allowLeaving) {
    return null;
  }

  const condition = conditionsMet ? '' : '_not';

  const contentPanel = (
    <ColumnWrapper>
      <Content
        dangerouslySetInnerHTML={{ __html: i18n.__(`session_leave_condition${condition}_met_${allowLeaving}`) }}
      />
    </ColumnWrapper>
  );

  const onContinue = async () => {
    setShowConfirmPopup(true);
  };

  const onConfirm = async () => {
    setShowConfirmPopup(false);
    const response = await postData(`/learn/${sessionId}/leave`);
    if (response.success) {
      onClose();
      window.location = '/me';
    } else {
      flash(i18n.__('app_error_alert'));
    }
  };

  return (
    <>
      <Popup
        popupIsOpen={popupIsOpen}
        heading={i18n.__('session_leave_header')}
        id="session-leave-popup"
        contentPanel={contentPanel}
        buttonLabel={i18n.__('session_leave_continue')}
        onClose={onClose}
        onClick={onContinue}
        buttonDisabled={loading || !conditionsMet}
      />
      <ConfirmPopup
        popupIsOpen={showConfirmPopup}
        id="confirmLeavePopup"
        title={i18n.__('session_leave_header')}
        message={i18n.__('app_confirm')}
        onConfirm={onConfirm}
        onCancel={() => setShowConfirmPopup(false)}
      />
    </>
  );
};

export default SessionLeavePopup;
